import type { ReactNode } from "react";

interface IntegrationTileProps {
  icon: ReactNode;
  title: string;
  description: string;
  badge: string;
  onClick: () => void;
  /** Optional status (a coloured dot) in the top right corner. */
  status?: ReactNode;
}

const IntegrationTile = ({ icon, title, description, badge, onClick, status }: IntegrationTileProps) => (
  <button
    type="button"
    className="group relative flex min-h-[200px] flex-col items-center justify-center gap-3 rounded-[24px] border border-slate-200/80 bg-white/95 p-6 text-center shadow-[0_14px_35px_rgba(15,23,42,0.08)] transition hover:-translate-y-0.5 hover:border-emerald-200 hover:shadow-[0_20px_45px_rgba(15,23,42,0.12)] focus:outline-none focus:ring-2 focus:ring-emerald-500 motion-reduce:transform-none motion-reduce:transition-none dark:border-white/10 dark:bg-slate-950/70 dark:hover:border-emerald-300/30"
    onClick={onClick}
  >
    {status ? <span className="absolute right-4 top-4">{status}</span> : null}
    <span className="rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-emerald-800 dark:border-emerald-500/40 dark:bg-emerald-900/25 dark:text-emerald-100">
      {badge}
    </span>
    <h2 className="flex items-center gap-2 text-2xl font-semibold text-emerald-800 dark:text-emerald-100">
      {icon}
      {title}
    </h2>
    <p className="text-slate-600 dark:text-slate-300">{description}</p>
  </button>
);

export default IntegrationTile;
